import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    constraints: {
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Amount paid',
    isOptional: false,
    name: 'Amount',
    partialId: PartialId.Standard.create('amount'),
    type: core.common.value.types.Intrinsic.Currency,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
